import { useMutation } from '@tanstack/react-query';
import { adminFetch } from '@/lib/apiClient';
import { idempotencyKeyFor } from '@/lib/http-core';
import type { PreviewContentType } from './sfOrigin';

const PATH = '/admin/v1/preview-tokens';

export interface PreviewTokenRequest {
  contentType: PreviewContentType;
  contentId: string;
  /** 기본 1440(24h). BE 가 미지정 시 적용. */
  ttlMinutes?: number;
}

export interface PreviewTokenResponse {
  token: string;
  /** BE url(host=dev localhost). 신뢰 금지 — token 으로 직접 조립한다(계약 §ID58). */
  url: string;
  expiresAt: string;
}

interface Envelope<T> {
  success?: boolean;
  data?: T | null;
}

/**
 * ID58: 미리보기 토큰 발급. POST /admin/v1/preview-tokens (201).
 * Idempotency-Key 필수(writeAllowlist 등록). 같은 contentType+contentId 더블클릭 시 중복 발급 방지.
 */
export const useCreatePreviewToken = () =>
  useMutation({
    mutationFn: async (body: PreviewTokenRequest): Promise<PreviewTokenResponse> => {
      const res = await adminFetch(PATH, {
        method: 'POST',
        headers: { 'Idempotency-Key': idempotencyKeyFor('POST', PATH, body) },
        body: JSON.stringify(body),
      });
      if (!res.ok) throw new Error(`preview token create failed: ${res.status}`);
      const env = (await res.json()) as Envelope<PreviewTokenResponse>;
      if (!env.data?.token) throw new Error('no token');
      return env.data;
    },
  });
